import(/* webpackMode: "eager" */ "/app/app/(home)/error.tsx");
